export const MARKETPLACE_LISTINGS_ANCHOR_ID = "marketplace-listings";

/** Scroll listings into view below the sticky marketplace header. */
export function scrollToMarketplaceResults() {
  requestAnimationFrame(() => {
    const el = document.getElementById(MARKETPLACE_LISTINGS_ANCHOR_ID);
    if (!el) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}
